import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';

@Component({
  selector: 'markant-platform-simple-widget-with-action',
  standalone: true,
  imports: [CommonModule, MarkantElementsModule],
  templateUrl: './simple-widget-with-action.component.html',
  styleUrls: ['./simple-widget-with-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleWidgetWithActionComponent {
  @Input() description: string | undefined;
  @Input() textTitle: string | undefined;
  @Input() widgetTitle: string | undefined;
  @Input() button: { label: string; action: () => void } | undefined;
}
